
import {Injectable, Inject} from 'ng-metadata/core';
import {ConfigurationUtil} from '../../../nddUtils/configurationUtil.service';
import {TemplateUtil} from '../../../nddUtils/templateUtil.service';
import {SearchStateService} from '../../searchState.service';
import { Cheetah } from '../../cheetah.service';
import { MappingTablesCache } from '../../../mappingTablesCache/mappingTablesCache.service';
import {getVid, getUrlContext, getBackendSystem, getDefaultScope} from '../../../appConfig/appConfigForward';

const flatten = require('lodash/flatten');
const forEach = require('lodash/forEach');
const _get = require('lodash/get');

@Injectable()
export class SendEmailService{
    private EMAIL_API_URL: string;
    private EXPORT_ALL_EMAIL_API_URL: string;
    private sendMailPerformance: number;
    private _renderedItems: string;
    private _templateRenderingInProgress: boolean = false;
    private isUseClassicTemplate: boolean = false;
    private vid: string = getVid();

    constructor(@Inject('$http') private $http: ng.IHttpService,
                private configurationUtil: ConfigurationUtil,
                private templateUtil: TemplateUtil,
                private searchStateService : SearchStateService,
                private cheetah: Cheetah,
                private mtCache:MappingTablesCache,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('restBaseURLs') private restBaseURLs,
                @Inject('$state') private $state: ng.ui.IStateService,
                @Inject('$stateParams') private $stateParams:angular.ui.IStateParamsService,
                @Inject('$httpParamSerializer') private $httpParamSerializer: ng.IHttpParamSerializer,){
        this.EMAIL_API_URL= restBaseURLs.actionsBaseURL+'/email'+ '?vid=' + this.vid;
        this.EXPORT_ALL_EMAIL_API_URL = restBaseURLs.exportAll;
        this.isUseClassicTemplate = (this.mtCache.getTable(this.mtCache.tables.VIEW_PROPERTIES).filter((row) => row.source1 === this.vid && row.source2 === 'use_classic_email_template' && row.target === 'true').length === 1);
    }

    private getLinkToOnline(item){
        let linksArr = [];
        let avaLinks = _get(item,'delivery.availabilityLinks') ? item.delivery.availabilityLinks : [];
        let avaLinksUrl = _get(item,'delivery.availabilityLinksUrl') ? item.delivery.availabilityLinksUrl : [];
        if (avaLinks.length > 0 && avaLinksUrl.length > 0) {
           for (let i=0; i< avaLinks.length; i++){
               if (avaLinks[i] === 'directlink' && avaLinksUrl[i].length > 0) {
                  let obj = {
                      linkLabel: this.isPhysical(item.delivery.deliveryCategory[i]),
                      linkURL: avaLinksUrl[i]
                  };

                  linksArr.push(obj);
               }
           }
        }
        return linksArr;
    }


       private isPhysical(delCategory) {
            let label = '';
            if ((delCategory === 'Physical Item') || (delCategory === 'Microform') || (delCategory === 'Alma-P')) {
                  label = 'physicalCopy';
            }
            else {
                label = 'onlineAccess';
            }
            return label;
         }



    private itemToRecord(item){
        let record={
            pnx:item.pnx,
            context:this.getContext(item),
            holdings: _get(item,'delivery.holding',[]),
            deeplink:this.getLinkByPageType(item),
            link2online:this.getLinkToOnline(item),
        };
        return record;
    }

    private getLinkByPageType(item){
        if (this.$state.current.name === "servicesPage"){
            return window.location.href;
        } else if(this.$state.current.name === "fulldisplay") {
            return this.templateUtil.getDeepLinkAbsPath(item, this.$state.params['search_scope'], this.$state.params['adaptor']);
        }

        return this.templateUtil.getDeepLinkAbsPath(item);
    }


    //returns payload json for send Email API
    private buildPaylod(addresses, subject, notes, items, captchaResponse, selectedIds, isFullView ?:boolean){
        let records= (selectedIds && !this.isTemplateSupported(selectedIds)) ? selectedIds : items.map((item)=>this.itemToRecord(item));
        let spLink = (this.$state.current.name === "servicesPage"?window.location.href:'');
        let payload= {
                'addresses': addresses,
                'subject': subject,
                'notes': notes,
                'language': this.$translate.use(),
                'vid': this.vid,
                'template': 'default',  //TODO: template should not be hardcoded
                'records': records,
                'captchaResponse':captchaResponse,
                'spLink':spLink
        }
        
        if(this.isTemplateSupported(records)){
            let template = this.buildTemplate(isFullView);
            payload['html'] = template;
        }    
        
            
        
        if (selectedIds) {
            this.buildAdditionalParamsPayload(payload);
        }
        
        return payload; 
    }

    private buildAdditionalParamsPayload(payloadObj){
        payloadObj.additionalParams = {
            state: this.$state.current.name,
                href: window.location.href,
                searchScope: this.$state.params['search_scope'] || this.searchStateService.getSearchObject().scope,
                adaptor: this.$state.params['adaptor'],
                baseUrl: this.templateUtil.getBaseUrl(),
                urlContext: getUrlContext(),
                curState: this.templateUtil.getCurState() 
        };
    }

    public getPnxForSelectedIds(selectedIds){
        const vid = getVid();
        const pushToSuffix = this.configurationUtil.isSuprima() ? '' : '/pushto';
        const apiUrl = `${this.restBaseURLs.actionsBaseURL}${pushToSuffix}/getPnx?vid=${vid}`
        let records = {records: selectedIds};
        return this.$http.post(apiUrl, records);
    }

        //builds payload json from parameters and calls send email API via post request returns promise object
    public sendEmail(addresses, subject, notes, items, captchaResponse, selectedIds, isFullView ?:boolean){
        
        let payload = this.buildPaylod(addresses, subject, notes, flatten(items), captchaResponse, selectedIds, isFullView);
        return this.$http.post(this.EMAIL_API_URL, payload); //'../primo_library/libweb/webservices/rest/v1/actions/email'
    }

    public sendExportAllEmail(addresses, subject, notes, captchaResponse, exportFormat, encodingOrFileType, excelFields){
        let payload = {
            'addresses': addresses,
            'subject': subject,
            'notes': notes,
            'captchaResponse': captchaResponse,
            'exportFormat': exportFormat,
            'encodingOrFileType': encodingOrFileType,
            'excelFields': excelFields
        };
        this.$http.post(this.EXPORT_ALL_EMAIL_API_URL + '?' + this.$httpParamSerializer(this.cheetah.searchData), payload); 
    }

    private getContext(item) {
        let recordId = item.pnx.control.recordid[0];
        let context = item.context;
        if (context === undefined){
            if (recordId.startsWith("TN_")) {
                context = "PC";
            }
            else {
                context = "L";
            }
        }
        return context;

    }

    private buildTemplate(isFullView ?:boolean):string{
        let templateId = isFullView ? 'email-template-full' : 'email-template-brief'
        let primoHTML = document.querySelector('#' + templateId);
        if(primoHTML && primoHTML.querySelector('#email-template-items')){
            primoHTML.querySelector('#email-template-items').innerHTML = this.renderedItems;
        }
        return primoHTML.innerHTML;
    }


    public isTemplateSupported(items){
        return items && items.length > 0 && items.length <= 50 && !this.isUseClassicTemplate;
    }

    get renderedItems(): string {
        return this._renderedItems;
    }

    set renderedItems(items: string) {
        this._renderedItems = items;
    }

    get templateRenderingInProgress(): boolean {
        return this._templateRenderingInProgress ;
    }

    set templateRenderingInProgress(inProgress: boolean) {
        this._templateRenderingInProgress = inProgress;
    }

}






// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/sendEmailAction/sendEmail.service.ts